module.exports = __webpack_public_path__ + "media/promo/hochland/images/v5-45b3006f6a3b418fc484e48b7bf64b29.png";